import React, { memo } from 'react';
import { Button, Box } from '@chakra-ui/react';

const CheckoutButton = memo(({ handleCheckout, loading, isDisabled }) => {
  return (
    <Box
      width="100%"
      py={4}
      mt={6}
      mb={2}
      bg="linear-gradient(180deg, rgba(26,32,44,0.8) 0%, rgba(26,32,44,0.95) 100%)"
      backdropFilter="blur(10px)"
      borderRadius="xl"
      boxShadow="lg"
    >
      <Button 
        colorScheme="teal" 
        size="lg" 
        w="100%" 
        onClick={handleCheckout} 
        isLoading={loading}
        isDisabled={isDisabled}
        height="60px"
        fontSize="xl"
        fontWeight="bold"
        borderRadius="xl"
        _hover={{ transform: 'translateY(-2px)', boxShadow: 'lg' }}
        transition="all 0.2s"
      >
        Finalizar Atendimento
      </Button>
    </Box>
  );
});

export default CheckoutButton;
